import React, { useState, useRef, useEffect } from 'react';
import { FaCalendar } from 'react-icons/fa';
import SingleDateCalendar from './SingleDateCalendar';
import { useNavigate } from 'react-router-dom';

const SingleDatePicker = ({ onDateSelect, initialSelectedDate }) => {
    const [isOpen, setIsOpen] = useState(false);
    console.log(initialSelectedDate, "initialSelectedDate");
    const [selectedDate, setSelectedDate] = useState(initialSelectedDate);
    const wrapperRef = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        setSelectedDate(initialSelectedDate);
    }, [initialSelectedDate]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);

    const handleSingleDateSelect = (date) => {
        setSelectedDate(date);
        onDateSelect(date);
        setIsOpen(false);

        if (date) {
            const parts = date.split('-');
            if (parts.length === 3) {
                const [year, month, day] = parts;
                const formattedUrlDate = `${day}-${month}-${year}`;
                navigate(`/dashboard/${formattedUrlDate}`);
            }
        } else {
            // ✅ Safe fallback when cleared
            navigate(`/dashboard`);
        }
    };

    const formatDateForDisplay = (dateStr) => {
        if (!dateStr) return 'Select Date';
        const parts = dateStr.split('-');
        if (parts.length === 3) {
            const [year, month, day] = parts;
            return `${day}-${month}-${year}`;
        }
        return dateStr;
    };

    return (
        <div className="relative z-50" ref={wrapperRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center self-start sm:self-center mt-2 sm:mt-0 px-3 py-2 text-sm text-gray-600 bg-white border rounded-lg w-64 font-[Archivo]"
            >
                <FaCalendar className="mr-2" /> 
                {/* {formatDateForDisplay(selectedDate)} */}
                {selectedDate}
            </button>
            {isOpen && (
                <div className="absolute left-0 mt-2 z-20 w-max animate-fade-in-slide-down font-[Archivo]">
                    <SingleDateCalendar
                        onDateSelect={handleSingleDateSelect}
                        initialSelectedDate={selectedDate}
                    />
                </div>
            )}
        </div>
    );
};

export default SingleDatePicker;
